// Generated by script, please do not edit this file.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import * as React from 'react';
import { forwardRef } from 'react';
var Global = function(props, ref) {
    return /*#__PURE__*/ React.createElement("svg", _object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 16 16",
        fill: "currentColor",
        ref: ref
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M7.5 15a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13m0 1a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M3.585 5.04a8 8 0 0 1-.785-.426L2 4l.5-.5h.442c.263.208.603.413.988.6C4.558 2.615 5.543 1.333 7 1.09V2c-.879 0-1.682 1.037-2.236 2.453C5.657 4.78 6.658 5 7.5 5c1.528 0 3.574-.721 4.558-1.5h.442l.5.5-.8.614C10.982 5.372 9.084 6 7.5 6c-.976 0-2.072-.238-3.054-.599A11.6 11.6 0 0 0 4 8.5C4 11.436 5.371 15 7 15v.98c-3-.5-4-5.48-4-7.48 0-.828.171-2.154.585-3.46"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M10.236 12.547C9.343 12.22 8.342 12 7.5 12c-1.528 0-3.574.721-4.558 1.5H2.5L2 13l.8-.614C4.018 11.628 5.916 11 7.5 11c.976 0 2.072.238 3.054.599.282-.992.446-2.083.446-3.099C11 5.564 9.629 2 8 2v-.91c3 .5 4 5.41 4 7.41 0 .823-.169 2.151-.578 3.463q.422.202.778.423L13 13l-.5.5h-.442a5.5 5.5 0 0 0-.975-.594C10.456 14.42 9.467 15.736 8 15.98V15c.879 0 1.682-1.037 2.236-2.453"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7 8V2h1v6h6v1H8v6H7V9H1V8z"
    }));
};
var ForwardRef = /*#__PURE__*/ forwardRef(Global);
export default ForwardRef;
